<template>
  <button type="button"
          @click="open = true">
    <slot></slot>
    <portal v-if="open"
            to="modals">
      <Modal @close="open = false"
             size="max-w-sm">
        <div class="text-lg mb-6 mt-2 leading-relaxed flex">
          <div class="pt-px">
            <BaseIcon name="alert-circle"
                      class="text-red-500 mt-px"
                      size="22" />
          </div>
          <div class="mx-3">
            {{ message }}
          </div>
        </div>
        <div class="flex -mx-5 -mb-5">
          <button class="btn btn-red w-1/2 py-3 rounded-none rounded-bl"
                  type="button"
                  @click.once="confirm()">{{ confirmText }}</button>
          <button class="cancel border-t border-gray-100 hover:bg-gray-100 w-1/2 py-3 rounded-br"
                  type="button"
                  @click="cancel()">Annuleren</button>
        </div>
      </Modal>
    </portal>
  </button>
</template>

<script>
import Modal from "./Modal";

export default {
  props: {
    message: {
      type: String,
      required: true
    },
    confirmText: {
      default: 'Ja, verwijderen'
    }
  },

  components: {
    Modal
  },

  data() {
    return {
      open: false
    };
  },

  methods: {
    confirm() {
      this.$emit("confirm");
      this.open = false;
    },

    cancel() {
      this.open = false;
    }
  }
};
</script>